import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { getBranch } from '../utils/orgData';
import { SLIVERS } from './SliverNav';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import StatusPill from '../components/primitives/StatusPill';
import { useLiveFeed } from '../components/live/LiveFeedProvider';
import TickerNumber from '../components/live/TickerNumber';

const { FiChevronRight, FiRefreshCw, FiSettings, FiTarget } = FiIcons;

const DashboardHeader = () => {
  const [time, setTime] = useState(new Date());
  const { branchId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const match = pathname.match(/\/sliver\/([^/]+)/);
  const sliverId = match ? match[1] : 'holistic';
  const sliver = SLIVERS.find((s) => s.id === sliverId) || SLIVERS[0];
  const branch = branchId ? getBranch(branchId) : null;

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const { tick } = useLiveFeed();

  return (
    <header className="h-20 bg-black border-b border-white/10 flex items-center justify-between px-8 shrink-0">
      <div className="flex items-center gap-6">
        <Link to={`/sliver/${sliverId}`} className="flex flex-col">
          <h1 className="font-doto font-black text-2xl xl:text-3xl leading-none text-white tracking-tighter">
            PG GLASS<span className="text-[#D71921]">.</span>
          </h1>
          <span className="font-mono-tech text-[9px] text-neutral-500 uppercase tracking-[0.25em] mt-1">
            GLASSVIEW_V1.0 // LIVE_OPS
          </span>
        </Link>

        <div className="flex items-center gap-2 ml-4">
          <Link
            to="/sliver/holistic"
            className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-white"
          >
            Group
          </Link>
          <SafeIcon icon={FiChevronRight} className="text-neutral-700 text-xs" />
          <Link
            to={`/sliver/${sliverId}`}
            className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-neutral-400 hover:text-white"
          >
            {sliver.label}
          </Link>
          {branch && (
            <>
              <SafeIcon icon={FiChevronRight} className="text-neutral-700 text-xs" />
              <span className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-white border border-white/15 px-2 py-1 bg-[#0A0A0A]">
                {branch.name}
              </span>
            </>
          )}
        </div>
      </div>

      <div className="flex items-center gap-6">
        <StatusPill tone="ok" pulse>Live_Stream</StatusPill>

        <div className="flex items-center gap-2 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-neutral-500">
          <span className="w-1.5 h-1.5 rounded-full bg-[#00FF41] animate-pulse" />
          <span>Tick_</span>
          <span className="text-[#00FF41]"><TickerNumber value={tick} digits={4} /></span>
        </div>

        <div className="text-right border-l border-white/10 pl-6">
          <div className="font-mono-tech text-sm text-white tracking-wider tabular-nums">
            {time.toLocaleTimeString('en-GB', { hour12: false })}
          </div>
          <div className="font-mono-tech text-[9px] text-neutral-500 uppercase tracking-[0.25em]">
            {time.toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' })}
          </div>
        </div>

        <button
          onClick={() => navigate(0)}
          className="w-10 h-10 flex items-center justify-center border border-white/10 text-neutral-400 hover:border-[#D71921] hover:text-[#D71921] transition-all"
          title="Refresh"
        >
          <SafeIcon icon={FiRefreshCw} />
        </button>
        <button
          className="w-10 h-10 flex items-center justify-center border border-white/10 text-neutral-400 hover:border-white/40 hover:text-white transition-all"
          title="Settings"
        >
          <SafeIcon icon={FiSettings} />
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
